module.exports = __webpack_public_path__ + "img/621.3d91976e.png";